// page-point ページのjs
import htmx from "htmx.org";
import { swiperThumbnail } from "../modules/_swiper-thumbnail";
import { Accordion } from "../modules/_accordion";
import ModalPopup from "../modules/_modalPopup";
import { Tab } from "../modules/_tab";
import "../sass/page-point.scss";

const tabFn = () => {
  const roots = document.querySelectorAll(".js-tab");
  if (roots.length === 0) return;
  roots.forEach((root) => {
    const t = new Tab(root);
    t.init();
  });
};

// モーダル
const modalFnc = () => {
  const modal = document.querySelectorAll('.js-modal');
  if (!modal.length) return;
  const Modal = new ModalPopup();
  const setCenterPosTbody = (TARGET) => {
    const tbody = [...TARGET.querySelectorAll('.modal-stock-table tbody')];
    if (!tbody) return;
    tbody.forEach((elm) => {
      const TBODY = elm;
      if (TBODY.childElementCount > 4) return;
      TBODY.style.justifyContent = 'center';
    });
  };
  for (let i = 0; i < modal.length; i += 1) {
    if (!navigator.userAgent.match(/iPhone|Android.+Mobile/)) setCenterPosTbody(modal[i]);
    Modal.init(modal[i], i);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const sliderLength = document.querySelectorAll(".swiper").length;
  for (let i = 1; i <= sliderLength; i += 1) {
    swiperThumbnail(`.goods-swiper-${i}`, `.goods-thumb-${i}`);
  }
});

// ▼▼▼▼▼ DOMが安定した後に実行
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
let LOADED_COUNT = 0;
htmx.on("htmx:afterSettle", () => {
  LOADED_COUNT += 1;

  if (HTMX_ELM_COUNT === LOADED_COUNT) {
    // ここにDOMが安定した後に実行したい処理を記述する
    tabFn();
    Accordion();
    modalFnc();
  }
});
// ▲▲▲▲▲
